import a11yScan from './a11y-scan';
import a11yScanner from './a11y-scanner';
import action from './action';
import article from './article';
import artist from './artist';
import asset from './asset';
import assetFormat from './asset-format';
import assetFormatRelation from './asset-format-relation';
import audioplayer from './audioplayer';
import audioplayerTrack from './audioplayer-track';
import calendarEvent from './calendar-event';
import category from './category';
import channel from './channel';
import collection from './collection';
import contest from './contest';
import contestFormField from './contest-form-field';
import coopPartner from './coop-partner';
import customShop from './custom-shop';
import digitalOrderConfig from './digital-order-config';
import division from './division';
import domain from './domain';
import externalReference from './external-reference';
import externalValue from './external-value';
import frontendUser from './frontend-user';
import job from './job';
import label from './label';
import link from './link';
import linkPattern from './link-pattern';
import liveEvent from './live-event';
import livePartner from './live-partner';
import location from './location';
import mediaEmbed from './media-embed';
import mediaEvent from './media-event';
import mediaPartner from './media-partner';
import newsletterTarget from './newsletter-target';
import organization from './organization';
import person from './person';
import product from './product';
import productContributor from './product-contributor';
import productElement from './product-element';
import productFamily from './product-family';
import productFamilyContributor from './product-family-contributor';
import section from './section';
import shopifyStore from './shopify-store';
import shortUrl from './short-url';
import tradePartner from './trade-partner';
import user from './user';
import userRole from './user-role';
import webSeries from './web-series';

export default {
  a11yScan,
  a11yScanner,
  action,
  article,
  artist,
  assetFormatRelation,
  assetFormat,
  asset,
  audioplayerTrack,
  audioplayer,
  calendarEvent,
  category,
  channel,
  collection,
  contest,
  contestFormField,
  coopPartner,
  customShop,
  digitalOrderConfig,
  division,
  domain,
  externalReference,
  externalValue,
  frontendUser,
  job,
  label,
  linkPattern,
  link,
  liveEvent,
  livePartner,
  location,
  mediaEmbed,
  mediaEvent,
  mediaPartner,
  newsletterTarget,
  organization,
  person,
  productContributor,
  productElement,
  productFamilyContributor,
  productFamily,
  product,
  section,
  shopifyStore,
  shortUrl,
  tradePartner,
  userRole,
  user,
  webSeries,
};
